import { Component, OnInit, Input, EventEmitter, Output} from '@angular/core';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'edit-action-button',
    templateUrl: './edit-button.component.html',
    styleUrls: ['./edit-button.component.scss'],
    standalone: true
})
export class EditButtonTableComponent implements OnInit {
    @Input() idEntity: string;
    @Output() editEvent = new EventEmitter();

    constructor() { }

    ngOnInit() {
    }

    editRoute(event) {
        this.editEvent.emit(this.idEntity);
    }

}
